import React, { useEffect, useState } from "react";
import { Box, Table, Tbody, Td, Text, Tr } from "@chakra-ui/react";
import { Tab, Tabs } from "react-bootstrap";
import VendorOverview from "./Overview";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { fetchAsyncGetVendorByID } from "redux/vendorSlice";
import { fetchAsyncGetAllVendorWithPayAmount } from "redux/vendorSlice";
import ExpenseDetails from "./expenseDetails";
import CreditDetails from "./creditDetails";
import { useToasts } from "react-toast-notifications";
import VendorLedger from "./vendorLedger/vendorLedger";
import VendorTransaction from "./vendorTransactions";

const VendorDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [allVendors, setAllVendors] = useState([]);
  const { addToast } = useToasts();

  const [vendorDetail, setVendorDetail] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  const fetchVendorDetails = async (vendorId) => {
    try {
      const res = await dispatch(fetchAsyncGetVendorByID(vendorId));
      if (res?.payload) {
        setVendorDetail(res.payload.vendor);
      }
    } catch (error) {
      addToast(`Error fetching vendor details:`, { appearance: "error" });
    }
  };
  const fetchAllVendors = async () => {
    try {
      const res = await dispatch(fetchAsyncGetAllVendorWithPayAmount());
      if (res?.payload) {
        setAllVendors(res.payload);
      }
    } catch (error) {
      addToast(`Error fetching vendor details:`, { appearance: "error" });
    }
  };

  useEffect(() => {
    fetchAllVendors();
  }, []);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  const filteredVendors = allVendors.filter((vendor) =>
    vendor.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );
  useEffect(() => {
    if (id) {
      fetchVendorDetails(id);
    }
  }, [id]);

  const navigate = useNavigate();

  const handleVendorClick = (e, _id) => {
    e.stopPropagation();

    navigate(`/vendor/${_id}`);
  };
  const [activeTab, setActiveTab] = useState("overview");
  const handleSelectTab = (k) => {
    setActiveTab(k);
  };
  return (
    <>
      <Box display="flex" className="mx-0 vendor_details">
        <Box className="vendor_details_sidebar">
          <Box className="all-vendor">
            <Text className="all-vendor-text">All Vendors</Text>
          </Box>
          <Box className="vendor-item">
            <input
              className="vendor-search-field"
              placeholder="Search vendors..."
              value={searchTerm}
              onChange={handleSearchChange}
              mb={4} // Margin bottom for spacing
            />
            <Table className="vendor-table">
              <Tbody>
                {filteredVendors &&
                  filteredVendors?.length > 0 &&
                  filteredVendors?.map((item, i) => {
                    return (
                      <Tr
                        className="table-row"
                        id={i + 1}
                        onClick={(e) => {
                          handleVendorClick(e, item?._id);
                        }}
                      >
                        <Td
                          className={`table-data ${
                            item?._id === id ? "active" : ""
                          }`}
                        >
                          <Box display="flex">
                            <Box className="mt-0 mx-2">
                              <input type="checkbox" id="checkbox" />
                            </Box>
                            <Box>
                              <Text
                                fontSize="14px"
                                fontWeight="500"
                                color="#000"
                              >
                                {item?.name}
                              </Text>
                              {/* <Text color="#4C526C">{formatAmountInINR(item?.totalPayoutAmount)}</Text> */}
                            </Box>
                          </Box>
                        </Td>
                      </Tr>
                    );
                  })}
              </Tbody>
            </Table>
          </Box>
        </Box>
        <Box className="vendor_details_main ledger">
          <Box className="main_details-header">
            <Text color="black" fontSize="22px" fontWeight="500" mt={5} mx={3}>
              {vendorDetail?.name}
            </Text>
            <Box className="sub_tab_header">
              <div>
                <Tabs
                  defaultActiveKey={activeTab ? activeTab : "overview"}
                  transition={false}
                  id="noanim-tab-example"
                  className="add-form-tabs px-2"
                  onSelect={handleSelectTab}
                >
                  <Tab
                    eventKey="overview"
                    title="Overview"
                    className="add-form-tab mx-0"
                  >
                    <Box>
                      <VendorOverview activeTab={activeTab} />
                    </Box>
                  </Tab>
                  <Tab
                    eventKey="expenses"
                    title="Expenses"
                    className="add-form-tab mx-0"
                  >
                    <ExpenseDetails activeTab={activeTab} />
                  </Tab>
                  <Tab
                    eventKey="creditDetails"
                    title="Credit Details"
                    className="add-form-tab mx-0"
                  >
                    <CreditDetails activeTab={activeTab} />
                  </Tab>
                  <Tab
                    eventKey="transactions"
                    title="Transactions"
                    className="add-form-tab mx-0"
                  >
                    <Box>
                      <VendorTransaction activeTab={activeTab} />
                    </Box>
                  </Tab>
                  <Tab
                    eventKey="Ledger"
                    title="Ledger"
                    className="add-form-tab mx-0"
                  >
                    <VendorLedger activeTab={activeTab} />
                  </Tab>
                </Tabs>
              </div>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default VendorDetails;
